import React from "react";
import { useOutletContext } from "react-router-dom";
import MyActionPlan from "./components/Action/MyActionPlan";
import LearnerContentFrame from "./components/LearnerContentFrame";

const MyActionPlanPage = () => {
  const { layoutPhase } = useOutletContext();

  return (
    <LearnerContentFrame layoutPhase={layoutPhase}>
      <MyActionPlan />
    </LearnerContentFrame>
  );
};

export default MyActionPlanPage;
